import gql from 'graphql-tag';

export const STORY_AUDIENCE_ARTICLE_GROOMING_STATUSES_QUERY = gql`
  query StoryAudienceArticleGroomingStatusesQuery($articleAudienceTemplates: [StoryAudienceArticleGroomingsInput!]!) {
    storyAudienceArticleGroomings(articleAudienceTemplates: $articleAudienceTemplates) {
      articleId
      audienceTemplateId
      audienceTemplateType
      status
    }
  }
`;
